import { render, staticRenderFns } from "./BottonBar.vue?vue&type=template&id=36f15094&scoped=true"
import script from "./BottonBar.vue?vue&type=script&lang=js"
export * from "./BottonBar.vue?vue&type=script&lang=js"
import style0 from "./BottonBar.vue?vue&type=style&index=0&id=36f15094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f15094",
  null
  
)

export default component.exports